exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".about-footer{margin:0;padding:15px 10px 15px 15px;border-top:1px solid #c0bfbf}.about-footer .top{width:100%}.about-footer .top .logo{display:inline-block;width:125px;text-align:left;font-size:9px;color:rgba(0,0,0,.7)}.about-footer .top .logo .windforce{width:50px;height:35px}.about-footer .top .logo .copyright{position:relative;bottom:5px;display:inline-block;width:70px}.about-footer .top .social{display:inline-block;width:calc(100% - 130px);text-align:right}.about-footer .top .social ul{position:relative;top:-15px}.about-footer .top .social li{margin-right:15px;display:inline}.about-footer .top .social li:last-child{margin-right:5px}.about-footer .top .social li a{text-decoration:none}.about-footer .top .social svg{width:12px;height:12px;cursor:pointer}.about-footer .bottom{text-align:left}.about-footer .bottom a{font-size:11px;color:rgba(0,0,0,.7);text-decoration:none}.about-footer .bottom a:first-child{margin-right:10px}.about-footer .bottom a:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/footer/aboutFooter.scss
// module id = 526
// module chunks = 0